import {
  AuthModalDefaultInput,
  AuthModalEmailInput,
  AuthModalInputMask,
  AuthModalPasswordInput,
} from "./components";

export const AuthModalInput = {
  Index: AuthModalDefaultInput,
  Email: AuthModalEmailInput,
  Password: AuthModalPasswordInput,
  Mask: AuthModalInputMask,
};
